import $ from 'jquery';
import AOS from 'aos';
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
import {wrapTable, wrapIframe} from '@shopify/theme-rte';
import {load} from './../exports/theme-sections';

$(document).ready(function() {

  // Load all registered sections on the page.
  load('*');

  // Animate on scroll
  var showAnimations = $('body').data('animations');
  if (showAnimations) {
    AOS.init({ once: true });
    $('body').addClass('aos-initialized');
  }

  // When images load, clear the background color
  document.addEventListener('lazyloaded', function(event) {
    $(event.target)
      .parent('.lazy-image')
      .css('background-image', 'none');
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';
  wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.rte iframe#admin_bar_iframe';
  wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  $(document).on('mousedown', function() {
    $('body').removeClass('focus-enabled');
  }).keyup(function(event) {
    // on TAB key press
    if (event.keyCode === 9) {
      $('body').addClass('focus-enabled');
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (window.navigator.cookieEnabled) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies',
    );
  }

  // Common a11y fixes
  focusHash();
  bindInPageLinks();

});

